import * as React from "react";
import type { SVGProps } from "react";
const SvgMorningSynced = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    viewBox="0 0 18 18" {...props}
  >
    <rect width={18} height={18} fill="#1D534F" rx={4} />
    <rect
      width={4.56}
      height={4.56}
      x={9.35}
      y={9.4}
      fill="#ADEE79"
      rx={1.22}
    />
    <rect
      width={4.56}
      height={4.56}
      x={4.19}
      y={9.4}
      fill="#ADEE79"
      rx={1.22}
    />
    <path
      fill="#ADEE79"
      d="M12.79 8.88H10.8c-1.03 0-1.59-1.16-.88-1.94l1.96-2.08c.75-.81 2.06-.22 2.06.9v1.95c0 .65-.5 1.17-1.15 1.17M4.19 7.71V5.76c0-1.07 1.3-1.66 2.05-.85l1.99 1.98c.75.79.19 1.99-.84 1.99H5.44c-.65 0-1.25-.52-1.25-1.17"
    />
  </svg>
);
export default SvgMorningSynced;
